import Input from "component/ui/Input";
import PageContainer from "component/ui/PageContainer";
import PageHeading from "component/ui/PageHeading";
import React, { useEffect, useState } from "react";
import profile from "../../assets/profile.png";
import Switch from "component/ui/Switch";
import SelectField from "component/ui/SelectField";
import {
  CARDS_ENUMS,
  accessibility,
  ageGroup,
  gamesSportOptions,
  genderOptions,
  no_player,
  playerFilter,
  venueSearch,
} from "helper/constant";
import MultiSelectWrapper from "component/ui/MultiSelectWrapper";
import DateAndTimePicker from "component/ui/Datepicker";
import SearchInput from "component/ui/SearchInput";
import { FiSearch } from "react-icons/fi";
import { FaPlus, FaUser } from "react-icons/fa";
import { BsFillPinAngleFill } from "react-icons/bs";
import Textarea from "component/ui/Textarea";
import RangeInput from "component/ui/ReactRange";
import Button from "component/ui/Button";
import { FcAlarmClock } from "react-icons/fc";
import july17 from "../../assets/july-17.png";
import pin from "../../assets/pin.png";
import idImg from "../../assets/id.png";
import { convertDateTimeUtc, createUniqueId, getCurrentcoords } from "helper/appConstant";
import { useDispatch, useSelector } from "react-redux";
import { getVenueSelectedSportsList } from "store/slice/profile";
import { createGameOn, fetchVenues } from "store/slice/booking";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FullPageLoader from "component/ui/fullPageLoader";
import moment from "moment";

const GameOn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedPlayer, setSelectedPlayer] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [formData, setFormData] = useState({ cardReferenceType: true, membershipFees: 0, isBookingRequired: false });
  const { venueSelectedSportsData, userProfileData } = useSelector((state) => state.profile);
  const { venuesList } = useSelector((state) => state.booking);
  const [coords, setCoords] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (venueSelectedSportsData?.length == 0) {
      dispatch(getVenueSelectedSportsList());
    }
    fetchCoords();
  }, []);

  useEffect(() => {
    if (coords) {
      getVenues();
    }
  }, [coords, formData?.category, userProfileData]);

  const validateEventFields = () => {
    const requiredFields = [
      { key: "cardReferenceID", label: "card Reference ID" },
      { key: "category", label: "Game / Sport" },
      { key: "noOfPlayers", label: "No of players" },
      { key: "skillsRequired", label: "Skill level" },
      { key: "ageGroup", label: "Age group" },
      { key: "startDate", label: "Start date" },
      { key: "startTime", label: "Start time" },
      { key: "endDate", label: "End date" },
      { key: "endTime", label: "End time" },
      // { key: "venueName", label: "Venue" },
    ];

    for (let field of requiredFields) {
      const value = formData?.[field.key];
      // empty / blank check
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        toast.error(`${field.label} is required`);
        return false;
      }
    }

    return true;
  };

  // Example submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEventFields()) return;
    const data = {
      ...formData,
      language: 'en',
      startDateTimeUtc: convertDateTimeUtc(formData?.startDate, formData?.startTime),
      endDateTimeUtc: convertDateTimeUtc(formData?.endDate, formData?.endTime)
    }
    setLoader(true);
    dispatch(createGameOn(data, navigate, setLoader));
  };

  const fetchCoords = async () => {
    try {
      const locationData = await getCurrentcoords();
      setCoords(locationData);
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    }
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getVenues = () => {
    const data = {
      "language": "en",
      "page": 1,
      "perPage": 50,
      "searchQuery": "",
      "sportName": formData?.category,
      "latitude": userProfileData?.data?.location?.coordinates[1],
      "longitude": userProfileData?.data?.location?.coordinates[0]
    };
    dispatch(fetchVenues(data));
  }

  return (
    <PageContainer>
      {loader && <FullPageLoader />}
      <div className="lg:max-w-5xl w-full mx-auto">
        <PageHeading title={"Game-On"} Subtitle={"Find a Player"} />
      </div>
      <div
        className="lg:max-w-5xl w-full mx-auto lg:p-6 p-3 rounded-lg bg-white"
      >
        <div className="space-y-4">
          <div className="flex items-center gap-3 mb-8">
            <img
              src={profile}
              alt="Profile image"
              className="w-12 h-12 rounded-full bg-gray-200 text-white flex items-center justify-center font-bold text-xl border  object-contain"
            />
            <p>Test</p>
          </div>
          <div className="mt-3">
            <h2 className="md:text-xl text-lg  font-semibold text-gray-800 flex items-center gap-2 md:mb-5 mb-4">
              <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
              <img src={idImg} alt="ID" className="w-5 h-5" /> Reference ID
            </h2>
            <div className="flex items-center justify-between mb-1">
              <label className="flex items-center text-sm font-semibold text-gray-700">
                Do you have a Refeence ID
                <span className="text-red-500 ml-1 font-bold">*</span>
              </label>

              <Switch checked={formData?.cardReferenceType} onChange={(e) => {
                if (e) {
                  handleChange(
                    "cardReferenceID", ""
                  );
                } else {
                  handleChange("cardReferenceID",
                    createUniqueId(CARDS_ENUMS?.GAME));
                }
                handleChange("cardReferenceType", e);
              }} />
            </div>
            <Input
              placeholder="Enter Reference ID"
              isRequired
              value={formData?.cardReferenceID}
              onChange={(e) => handleChange("cardReferenceID", e.target.value)} />
          </div>

          <div className="flex items-center justify-between">
            <label className="flex items-center text-sm font-semibold text-gray-700">
              Emergency requirement
              <span className="text-red-500 ml-1 font-bold">*</span>
            </label>

            <Switch checked={formData?.isItAnEmergency} onChange={(e) => handleChange("isItAnEmergency", e)} />
          </div>

          <h2 className="md:text-xl text-lg  font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
            <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
            🏏 Game Details
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <SelectField
              label="Select game or sport"
              value={formData?.category}
              onChange={(value) => handleChange("category", value)}
              isSport={true}
              options={venueSelectedSportsData}
              isRequired={true}
              placeholder="Select game or sport"
            />

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Accessibility <span className="text-red-500 ml-1">*</span>
              </label>

              <MultiSelectWrapper
                label="Accessibility"
                isRequired
                options={accessibility}
                value={formData?.accessibility}
                onChange={(value) => handleChange("accessibility", value)}
                placeholder="Select Accessibility"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Preferred gender <span className="text-red-500 ml-1">*</span>
              </label>

              <MultiSelectWrapper
                label="Preferred gender"
                isRequired
                options={genderOptions}
                value={formData?.prefGender}
                onChange={(value) => handleChange("prefGender", value)}
                placeholder="Select gender"
              />
            </div>

            <SelectField
              label="No of players required"
              value={formData?.noOfPlayers}
              onChange={(value) => handleChange("noOfPlayers", value)}
              options={no_player}
              isRequired={true}
              placeholder="Required number of players"
            />

            <SelectField
              label="Preferred skill level"
              value={formData?.skillsRequired}
              onChange={(value) => handleChange("skillsRequired", value)}
              options={playerFilter}
              isRequired={true}
              placeholder="Select preferred skill"
            />

            <SelectField
              id="age-select"
              label="Age group playing"
              isRequired
              placeholder="Age group playing"
              name="age"
              options={ageGroup}
              value={formData?.ageGroup}
              onChange={(value) => handleChange("ageGroup", value)}
            />
          </div>

          <div>
            <h2 className="md:text-xl text-lg font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
              <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
              <img src={july17} alt="date" className="w-5 h-5" />
              <FcAlarmClock fill="#ff0000" /> Schedule
            </h2>

            <>
              <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
                Date & Time
                <span className="text-red-500 ml-1 font-bold">*</span>
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <DateAndTimePicker
                  showDate
                  showTime={false}
                  placeholderDate="Start Date"
                  isRequired
                  inputClassName="w-full"
                  selectedDate={formData?.startDate}
                  onDateChange={(date) => handleChange("startDate", date ? moment(date).format("YYYY-MM-DD") : "")}
                />
                <Input
                  type="time"
                  isRequired
                  value={formData?.startTime}
                  onChange={(time) => handleChange("startTime", time)}
                />

                <DateAndTimePicker
                  showDate
                  showTime={false}
                  placeholderDate="End Date"
                  isRequired
                  inputClassName="w-full"
                  selectedDate={formData?.endDate}
                  onDateChange={(date) => handleChange("endDate", date ? moment(date).format("YYYY-MM-DD") : "")}
                />
                <Input
                  type="time"
                  isRequired
                  value={formData?.endTime}
                  onChange={(time) => handleChange("endTime", time)}
                />
              </div>
            </>
          </div>

          <>
            <h2 className="md:text-xl text-lg  font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
              <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
              <img src={pin} alt="pin" className="w-5 h-5" /> Venue Details
            </h2>
            <SearchInput
              value={formData?.venue}
              label="Venue name"
              isRequired
              onFocus={() => setSelectedPlayer(true)}
              placeholder="Search conversation"
              icon={FiSearch}
            />
          </>

          <div>
            <h2 className="md:text-xl text-lg font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
              <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
              <FaPlus /> <BsFillPinAngleFill fill="#ff0000" /> Extras
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-center justify-between">
                <label className="flex items-center text-sm font-semibold text-gray-700">
                  Booking required
                  <span className="text-red-500 ml-1 font-bold">*</span>
                </label>

                <Switch
                  checked={formData?.isBookingRequired}
                  onChange={(value) => handleChange("isBookingRequired", value)} />

              </div>

              {formData?.isBookingRequired && <Input
                label="Booking details"
                placeholder="Enter booking details if any"
                required
                className="w-full"
                value={formData?.bookingText}
                onChange={(e) => handleChange("bookingText", e)}
              />}

              <div className="flex items-center justify-between">
                <label className="flex items-center text-sm font-semibold text-gray-700">
                  Kit required
                  <span className="text-red-500 ml-1 font-bold">*</span>
                </label>

                <Switch
                  checked={formData?.isBringYourOwnGameSportKit}
                  onChange={(value) => handleChange("isBringYourOwnGameSportKit", value)} />
              </div>

              {formData?.isBringYourOwnGameSportKit && <Input
                label="Kit items details"
                placeholder="Enter the details of the kit items required"
                required
                className="w-full"
                value={formData?.yourOwnGamesSportKit}
                onChange={(e) => handleChange("yourOwnGamesSportKit", e)}
              />}
              <Textarea
                id="message"
                label="Description"
                placeholder="Enter description"
                rows={6}
                value={formData?.description}
                onChange={(e) => handleChange("description", e.target.value)}
              />
              <RangeInput
                label="Membership fees(if any)"
                placeholder="Member Fees"
                min={0}
                max={2000}
                step={1}
                value={formData?.membershipFees}
                onChange={(val) => handleChange("membershipFees", val)}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-5">
          <Button
            onClick={handleSubmit}>Post Sport/Game Card</Button>
        </div>
      </div>

      {selectedPlayer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fadeIn">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-white">Venue name</h3>
              <button
                onClick={() => setSelectedPlayer(null)}
                className="text-white text-xl hover:opacity-80"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <SearchInput
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search venue name or @username"
                icon={FiSearch}
              />

              <div className="overflow-y-auto h-96 thin-scrollbar">
                {venuesList.map((item, index) => (
                  <div className="flex items-center justify-between my-3 pr-4"
                    onClick={() => {
                      handleChange("venue", item?.name);
                      handleChange("venueName", item?.id);
                      handleChange("address", item?.address);
                      handleChange("coordinates", item?.coordinates);
                      setSelectedPlayer(false)
                    }}>
                    <div className="flex items-center gap-5">
                      <img
                        src={item.imageUrl}
                        alt={item.name}
                        className="w-10 h-10 rounded-full"
                      />
                      <p>{item.name}</p>
                    </div>
                    <FaUser fill="#2bace2" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )
      }
    </PageContainer >
  );
};

export default GameOn;
